/**
 * 오른쪽 사이드바 섹션 컴포넌트
 * 레이아웃 구조만 제공하며, 실제 컨텐츠는 renderContent prop으로 받음
 */ import React from 'react';
import { RightSidebarContainer } from '../../styles/layout.styles';
import styled from '@emotion/styled';
// Resize handle component - pill shaped
const ResizeHandle = styled.div`
  position: absolute;
  left: -12px; /* Moved further left to avoid overlapping with content */
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 48px;
  cursor: col-resize;
  background-color: var(--theme-border, #e1e8ed);
  border-radius: 4px;
  transition: all 0.2s ease;
  z-index: 1000; /* Increased z-index to ensure it's above content */
  pointer-events: auto; /* Explicitly enable pointer events */
  
  /* Create a larger hit area for easier grabbing */
  &::before {
    content: '';
    position: absolute;
    top: -8px;
    left: -4px;
    right: -4px;
    bottom: -8px;
    cursor: col-resize;
    pointer-events: auto; /* Ensure hit area captures events */
  }
  
  &:hover {
    background-color: var(--theme-primary, #1d9bf0);
    transform: translateY(-50%) scale(1.1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    background-color: var(--theme-primary-hover, #1a8cd8);
    transform: translateY(-50%) scale(0.95);
  }
  
  /* Visual indicator dots */
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 2px;
    height: 16px;
    background-image: radial-gradient(circle, var(--theme-text-secondary, #536471) 1px, transparent 1px);
    background-size: 2px 4px;
    background-repeat: repeat-y;
    opacity: 0.5;
    pointer-events: none; /* Dots should not capture events */
  }
`;
const RightSidebarSection = ({ showRightSidebar, isChatSidebarMode, isMobileView, isResizing, chatSidebarWidth, setIsResizing, setIsChatSidebarMode, isVSCodeEnv, isAuthenticated, renderContent, defaultContent })=>{
    if (!(showRightSidebar || isChatSidebarMode) || isMobileView) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(RightSidebarContainer, {
        "data-testid": "main-right-sidebar",
        $isVisible: true,
        className: isResizing ? 'resizing' : '',
        style: {
            position: 'relative',
            userSelect: isResizing ? 'none' : 'auto',
            width: `${chatSidebarWidth}px`,
            borderLeft: '1px solid var(--theme-border)',
            overflow: 'hidden' /* Prevent content from overlapping resize handle */ 
        },
        ref: (el)=>{
            if (el) {
                console.log('[RightSidebarContainer] Size:', {
                    chatSidebarWidth,
                    offsetWidth: el.offsetWidth,
                    offsetHeight: el.offsetHeight,
                    clientWidth: el.clientWidth,
                    clientHeight: el.clientHeight,
                    computedWidth: window.getComputedStyle(el).width
                });
            }
        }
    }, /*#__PURE__*/ React.createElement(ResizeHandle, {
        onMouseDown: (e)=>{
            console.log('[ResizeHandle] Mouse down event triggered');
            console.log('[ResizeHandle] Event target:', e.target);
            console.log('[ResizeHandle] Current target:', e.currentTarget);
            setIsResizing(true);
            e.preventDefault();
            e.stopPropagation();
        },
        onTouchStart: (e)=>{
            console.log('[ResizeHandle] Touch start event triggered');
            setIsResizing(true);
            e.preventDefault();
            e.stopPropagation();
        }
    }), isChatSidebarMode && renderContent ? renderContent() : defaultContent || /*#__PURE__*/ React.createElement("div", null, "Right Sidebar Placeholder"));
};
export default RightSidebarSection;
